<template>
	<div class="cash-from-courier">
		<NP-Select
			id="sender_order_id"
			label="ПНФП вiдправник"
			placeholder="Оберіть вiдправника"
			v-model="formData.sender_order"
			:options="pendingOrdersOptions"
			:async-options="listPending"
			do-empty-search-on-init
			@select="handleSelect"
		/>
		<div class="banknotes-wrap">
			<NP-Banknotes
				v-model="formData.cash"
				:banknote-denominations="banknoteDenominations"
				:coin-denominations="coinDenominations"
				:lists="lists"
				:disabled="!Boolean(formData.sender_order)"
			/>
		</div>
	</div>
</template>

<script>
import { formatters } from 'novapay-ui';

import { enum as banknoteDenominations } from '@repo/enums/banknote-denominations';
import { enum as coinDenominations } from '@repo/enums/coin-denominations';

export default {
	name: 'CashFromCourierForm',
	props: {
		ordersLeft: { type: Array, default: () => null },
		listPendingCashFromCourierSalepoint: { type: Function, default: null },
		lists: { type: Object, default: null }
	},
	data() {
		return {
			banknoteDenominations,
			coinDenominations,
			formData: this.getFormData(),
			pendingOrdersOptions: []
		};
	},
	computed: {
		firstExistFormData() {
			return this.pendingOrdersOptions.length ? this.pendingOrdersOptions[0] : null;
		},
		sender_order_id() {
			return this.formData.sender_order?.id;
		},
		sender_order_amount() {
			return this.formData.sender_order?.amount;
		}
	},
	methods: {
		getFormData() {
			return {
				sender_order: null,
				cash: null
			};
		},
		handleSelect(row) {
			this.formData.cash = row.cash;
		},
		mapOrders(orders) {
			return orders.map((row) => {
				let amount = formatters.formatMoney(row.factual_amount);
				return {
					id: row.id,
					amount: amount.replace(/\s/g, ''),
					text: `сума ${amount}, ПНФП №${row.salepoint_code} через ${[
						row.participant_last_name,
						row.participant_first_name,
						row.participant_patronymic
					].join(' ')};`,
					cash: row.cash
				};
			});
		},
		listPending() {
			if (this.ordersLeft) {
				this.pendingOrdersOptions = this.mapOrders(this.ordersLeft);
				if (this.firstExistFormData) {
					this.formData.sender_order = this.firstExistFormData;
					this.formData.cash = this.firstExistFormData?.cash;
				}
				return Promise.resolve();
			}

			return this.listPendingCashFromCourierSalepoint({
				cb: (res) => {
					this.pendingOrdersOptions = this.mapOrders(res.data || []);
				}
			});
		}
	},
	watch: {
		ordersLeft() {
			this.formData = this.getFormData();
			this.formData.sender_order = this.firstExistFormData;
			this.listPending();
		},
		formData: {
			handler: function () {
				this.$emit('input', {
					sender_order_id: this.sender_order_id,
					amount: this.sender_order_amount,
					cash: this.formData.cash
				});
			},
			deep: true
		}
	}
};
</script>

<style lang="scss" scoped>
.cash-from-courier {
	.banknotes-wrap {
		display: flex;
		margin-top: 16px;
	}
}
</style>
